export function signInSlient(_a) {
    var username = _a.username, password = _a.password;
    var result = (username === 'demo' && password === 'demo') ? true : false;
    return new Promise(function (resolve) {
        return setTimeout(function () { return resolve({ data: result }); }, 500);
    });
}
